import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

import React, { useEffect } from "react"
import Lenis from "@studio-freight/lenis"

/* ===========================
   Lenis インスタンス保持
=========================== */
let lenisInstance = null

/* ===========================
   ページラップ（Lenis）
=========================== */
const WrapWithLenis = ({ element }) => {
  useEffect(() => {
    if (typeof window === "undefined") return

    lenisInstance = new Lenis({
      duration: 1.2,
      smooth: true,
    })

    const raf = (time) => {
      lenisInstance?.raf(time)
      requestAnimationFrame(raf)
    }
    requestAnimationFrame(raf)

    return () => {
      lenisInstance?.destroy()
      lenisInstance = null
    }
  }, [])

  return <>{element}</>
}

export const wrapPageElement = ({ element }) => {
  return <WrapWithLenis element={element} />
}

/* ===========================
   ルート遷移時の処理
=========================== */
export const onRouteUpdate = () => {
  /* 🔽 Lenis のスクロール位置を強制リセット */
  if (lenisInstance) {
    lenisInstance.scrollTo(0, { immediate: true })
  }

  /* 🔽 フェードイン処理 */
  if (typeof document !== "undefined") {
    const elements = document.querySelectorAll(".fadeInUp")

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on")
          }
        })
      },
      { threshold: 0.1 }
    )

    elements.forEach((el) => observer.observe(el))
  }
}

/* ===========================
   JS 有効クラス
=========================== */
export const onClientEntry = () => {
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("js")
  }
}
